/* Product photos on the image server (dsv7iunirnrax.cloudfront.net/<product id>/<SKU>-N.<ext>) were first
   uploaded as .jpg; newer products are .png. The old card, swatch-hover and recently-viewed code builds
   every address with .jpg, so on those products the photo never changes. This reads each product's real
   file list once (the same list the new builder uses) and quietly points .jpg addresses at the file
   that exists. Nothing changes for products whose .jpg files are there. */
(function () {
  if (window.__tsImgExt) return; window.__tsImgExt = true;
  /* The image server now keeps a compressed .webp next to many .jpg/.png photos. Every gallery that reads the
     product's file list would show each photo twice, so the list is cleaned once here, for every caller:
     one file per photo, the original (.jpg/.png) when there is one, else whatever exists. */
  var LISTURL = 'https://1yi00t63hl.execute-api.us-east-1.amazonaws.com/v1/';
  function dedupe(list) {
    if (!Array.isArray(list)) return list;
    var rank = function (u) { return /\.jpe?g$/i.test(u) ? 0 : /\.png$/i.test(u) ? 1 : /\.webp$/i.test(u) ? 3 : 2; };
    var best = {}, order = [];
    list.forEach(function (u) {
      var m = String(u).match(/^(.*)\.(\w+)$/); var stem = m ? m[1].toLowerCase() : String(u);
      if (!(stem in best)) { best[stem] = u; order.push(stem); } else if (rank(u) < rank(best[stem])) best[stem] = u;
    });
    return order.map(function (k) { return best[k]; });
  }
  if (window.fetch) {
    var of = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = of.apply(this, arguments);
      if (url.indexOf(LISTURL) !== 0) return p;
      return p.then(function (r) {
        if (!r.ok) return r;
        return r.clone().json().then(function (j) {
          return new Response(JSON.stringify(dedupe(j)), { status: r.status, statusText: r.statusText, headers: { 'Content-Type': 'application/json' } });
        }).catch(function () { return r; });
      });
    };
  }
  var HOST = 'https://dsv7iunirnrax.cloudfront.net/', LIST = 'https://1yi00t63hl.execute-api.us-east-1.amazonaws.com/v1/';
  var RE = /^(?:https?:)?\/\/dsv7iunirnrax\.cloudfront\.net\/(\d+)\/([^\/?#]+)\.jpg(\?[^#]*)?$/i;
  var files = {}, asked = {};   // product id -> { lower-case stem: real url }; asked: product id -> promise
  function load(pid) {
    if (!pid) return Promise.resolve();
    if (asked[pid]) return asked[pid];
    return (asked[pid] = fetch(LIST + pid).then(function (r) { return r.ok ? r.json() : []; }).then(function (list) {
      var m = {}; (Array.isArray(list) ? list : []).forEach(function (u) {
        var k = String(u).match(/\/(\d+)\/([^\/]+)\.(\w+)$/); if (k) { var stem = k[2].toLowerCase(); if (!m[stem] || /jpe?g/i.test(k[3])) m[stem] = u; }
      });
      files[pid] = m;
    }).catch(function () { files[pid] = files[pid] || {}; }));
  }
  function fix(url) {
    var k = RE.exec(String(url || '').trim()); if (!k) return url;
    var m = files[k[1]]; if (!m) { load(k[1]); return url; }
    var real = m[k[2].toLowerCase()]; return real && !/\.jpe?g$/i.test(real) ? real : url;
  }
  function fixSet(v) { return String(v).split(',').map(function (part) { var p = part.trim().split(/\s+/); p[0] = fix(p[0]); return p.join(' '); }).join(', '); }
  // every way the old code sets a photo: img.src = …, setAttribute('src'|'srcset'|'data-src'|'data_src', …), new Image().src probes
  var d = Object.getOwnPropertyDescriptor(HTMLImageElement.prototype, 'src');
  if (d && d.set) Object.defineProperty(HTMLImageElement.prototype, 'src', { configurable: true, enumerable: d.enumerable, get: d.get, set: function (v) { d.set.call(this, fix(v)); } });
  var ds = Object.getOwnPropertyDescriptor(HTMLImageElement.prototype, 'srcset');
  if (ds && ds.set) Object.defineProperty(HTMLImageElement.prototype, 'srcset', { configurable: true, enumerable: ds.enumerable, get: ds.get, set: function (v) { ds.set.call(this, fixSet(v)); } });
  var sa = Element.prototype.setAttribute;
  Element.prototype.setAttribute = function (n, v) {
    if (this.tagName === 'IMG' && typeof v === 'string' && v.indexOf('dsv7iunirnrax') > -1) {
      var ln = String(n).toLowerCase();
      if (ln === 'src' || ln === 'data-src' || ln === 'data_src') v = fix(v); else if (ln === 'srcset') v = fixSet(v);
    }
    return sa.call(this, n, v);
  };
  // read the file lists ahead of the first hover: every product card / recently viewed item on the page
  function scan(root) {
    (root || document).querySelectorAll('[data-product-id],[data-pid],[data-attr]').forEach(function (el) { var id = idOf(el); if (id) prefetch(id); });
  }
  var queue = [], busy = 0;
  function prefetch(id) { if (asked[id] || queue.indexOf(id) > -1) return; queue.push(id); pump(); }
  function pump() { while (busy < 4 && queue.length) { busy++; load(queue.shift()).then(done, done); } function done() { busy--; pump(); } }
  function idOf(el) { var id = el.getAttribute('data-product-id') || el.getAttribute('data-pid') || el.getAttribute('data-attr'); return /^\d{8,}$/.test(id) ? id : ''; }
  document.addEventListener('pointerover', function (e) { var c = e.target.closest && e.target.closest('[data-product-id],[data-pid],[data-attr]'); if (c && idOf(c)) load(idOf(c)); }, { passive: true });
  // a .jpg that was set before its product's list arrived: once the list is in, swap to the real file
  document.addEventListener('error', function (e) {
    var t = e.target; if (!t || t.tagName !== 'IMG' || t.__tsFixed) return;
    var k = RE.exec(t.getAttribute('src') || ''); if (!k) return;
    load(k[1]).then(function () { var real = fix(t.getAttribute('src')); if (real !== t.getAttribute('src')) { t.__tsFixed = 1; t.removeAttribute('srcset'); t.src = real; } });
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); }); else scan();
  // cards added later (infinite scroll, recently viewed)
  if (window.MutationObserver) new MutationObserver(function (ms) { ms.forEach(function (m) { m.addedNodes.forEach(function (n) { if (n.nodeType === 1) scan(n); }); }); }).observe(document.documentElement, { childList: true, subtree: true });
})();
